import ui from "./ui.js";
import materials from "./materials.js";


export default function options(model, originalMaterial, scene, camera){
    const {mainRadios,sidewallsRadios, equipmentCheckbox, materialRadios, tableRadios} = ui()
    let firstLoadForMain = true
    let firstLoadForSidewalls = true
    let firstLoadForTable = true
    let firstLoadForMaterial = true
    const priceValue = document.querySelector('.price-value')

    const defaultPrice = 200

    const {materialDotMarble, materialWood, materialDarkMarble, materialMarbleTex} = materials(scene)
    const urlParams = new URLSearchParams(window.location.search);

    const mainParam = urlParams.get('main');
    const sidewallsParam = urlParams.get('sidewalls');
    const tableParam = urlParams.get('table');
    const materialsParam = urlParams.get('materials');


    mainRadios.forEach((item)=>{
        if (mainParam === item.value && firstLoadForMain) {
            item.checked = true
            changeColor(mainParam)
            firstLoadForMain = false
        }

        item.addEventListener('change', event => {
            changeColor(event.target.value)
        });

        function changeColor(data){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.material.name === 'Fasad') {
                        child.material.color.set(data)
                        child.material.color.multiplyScalar(1)
                        child.material.needsUpdate = true
                    }
                }
            });
        }
    })

    sidewallsRadios.forEach((item)=>{
        if (sidewallsParam === item.value && firstLoadForSidewalls) {
            item.checked = true
            changeColor(sidewallsParam)
            firstLoadForSidewalls = false
        }

        item.addEventListener('change', event => {
            changeColor(event.target.value)
        });

        function changeColor(data){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.material.name === 'Sideway') {

                        child.material.color.set(data)
                        child.material.color.multiplyScalar(1)
                        child.material.needsUpdate = true
                    }
                }
            });
        }
    })

    tableRadios.forEach((item)=>{
        if (tableParam === item.value && firstLoadForTable) {
            item.checked = true
            changeColor(tableParam)
            firstLoadForTable = false
        }

        item.addEventListener('change', event => {
            changeColor(event.target.value)
        });

        function changeColor(data){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.material.name === 'Island') {
                        child.material.color.set(data)
                        child.material.color.multiplyScalar(1)
                        child.material.needsUpdate = true
                    }
                }
            });
        }
    })

    equipmentCheckbox.forEach((item)=>{
        item.addEventListener('change', event => {
            changeEquipment(event.target.dataset.text, event.target.checked)
        });

        function changeEquipment(data, value){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.name === 'Dish' && data === 'Dishes' ) {
                        child.visible = value
                    }

                    if (child.name === 'dish2' && data === 'Dishes' ) {
                        child.visible = value
                    }

                    if (child.name === 'Mesh' && data === 'Table' ) {
                        child.visible = value
                    }

                    if (child.name ==='Mesh_1' && data === 'Table' ) {
                        child.visible = value
                    }

                    if (child.name ==='MarbleIslandTable' && data === 'Table' ) {
                        child.visible = value
                    }

                    if (child.name ==='IslandTable' && data === 'Table' ) {
                        child.visible = value
                    }
                }
            });
        }
    })

    materialRadios.forEach((item)=>{
        if (materialsParam === item.value && firstLoadForMaterial) {
            item.checked = true
            changeMaterial(materialsParam)
            firstLoadForMaterial = false
        }

        item.addEventListener('change', event => {
            changeMaterial(event.target.value)
        })

        function changeMaterial(data){
            calculatePrice()

            model.traverse( (child) => {
                if (child.isMesh) {
                    if (child.material.name === 'Table') {
                        if (data === 'default'){
                            child.material = originalMaterial
                        }

                        if (data === 'gray-marble'){
                            child.material = materialDotMarble
                            child.material.name = 'Table'
                        }


                        if (data === 'wood'){
                            child.material = materialWood
                            child.material.name = 'Table'
                        }

                        if (data === 'dark-marble'){
                            child.material = materialDarkMarble
                            child.material.name = 'Table'
                        }
                    }
                }
            })
        }
    })

    function calculatePrice(){
        let price = defaultPrice
        mainRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        sidewallsRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        tableRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        equipmentCheckbox.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        priceValue.textContent = price

    }
}